import * as RadixSelect from '@radix-ui/react-select'

import { styled } from '~/styled'

export const SelectMenuSeparator = styled(RadixSelect.Separator, {
  base: ['h-px', 'bg-grey-200', 'my-2', 'mx-1']
})
